import { Pipe, PipeTransform } from '@angular/core';
import { Realisation } from 'src/app/classes/realisation';
import { environment } from 'src/environments/environment';

@Pipe({
    name: 'isWorktime',
})
export class IsWorktimePipe implements PipeTransform {
    transform(realisation: Realisation, ...args: unknown[]): unknown {
        return environment.worktimeHourTypes.includes(realisation.hourtype);
    }
}
